import { ConditionalPartial } from '../../../utils';

import { CreateApprovedCarrierRequestDto } from './create-approved-carrier.request.dto';

/**
 * DTO for updating approved carrier configuration
 * All fields are optional for partial updates
 */
export class UpdateApprovedCarrierRequestDto extends ConditionalPartial(CreateApprovedCarrierRequestDto) { }
